"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFieldLayoutSize = void 0;
const styles_1 = require("../../../helpers/styles");
const getFieldLayoutSize = (size, widthSize) => {
    const selectedSize = size || widthSize;
    return typeof selectedSize === 'string' ? selectedSize : (0, styles_1.calcWidth)(selectedSize);
};
exports.getFieldLayoutSize = getFieldLayoutSize;
//# sourceMappingURL=getFieldLayoutSize.js.map